const ApiRoutes = {
  baseUrl: "https://qpay-project-management.vercel.app",
  // baseUrl: "http://localhost:3003",
  login: "/employee/login",
  profile: "/employee/profile",
  updateProfile: "/employee/update-profile",
  employeeBirthDay: "/employee/today-birthday",
  assignedProjects: "/employee/assined-projects",
  myProjects: "/employee/my-projects",
  addReport: "/employee/report/add",
  getReport: "/employee/report/list",
  applyLeave: "/leave/apply",
  getLeave: "/leave/list",
  getTasks: "/employee/task/list",
  getPendingTasks: "/employee/task/pending",
  updateTaskStatus: "/employee/task/update-status",
  addProject: "/employee/add-project",
  addModule: "/employee/add-module",
  addAttendance: "/employee/attendance/add",
  getAttendance: "/employee/attendance/list",
  holidayList: "/employee/holiday/list",
  holidaytomarrow: "/employee/holiday/tomarrow",
  todayAttendance: "/employee/attendance/today",
  addAdditionalReport: "/employee/additional-hours/add",
  getAdditionalReports: "/employee/additional-hours/list",
  addMeeting: "/employee/meeting/add",
  getMeetings: "/employee/meeting/list",

  // Admin / Manager Routes
  getAllEmployees: "/employees/list",
  addEmployee: "/employees/add",
  updateEmployee: "/employees/update",
  deleteEmployee: "/employees/delete",
  updateEmployeeStatus: "/employees/update-status",

  adminAllReports: "/report/list",
  projectList: "/project/list",
  updateProject: "/project/update",
  deleteProject: "/project/delete",

  moduleList: "/projectmodule/list",
  updateModule: "/projectmodule/update",
  deleteModule: "/projectmodule/delete",

  assignmentsList: "/assignments/list",
  addAssignment: "/assignments/add",
  updateAssignment: "/assignments/update",
  deleteAssignment: "/assignments/delete",
  projectModulesByProject: "/projectmodule/project-modules",

  adminReportCount: "/admin/report-count",
  adminReportSummary: "/report/summary",
  adminAdditionalHours: "/additional-hours/list",
  adminAttendanceList: "/attendance/list",
  adminMeetingsList: "/admin/meeting/list",
};

export default ApiRoutes;
